import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ToneTag, ToneTagCellParams } from '../../models/tone-tag.model';

/** An AG Grid cell drawing a coloured tag in the `tone-tag` style; the column's `tagFor` picks its text and tone. */
@Component({
  selector: 'gains-tone-tag-cell',
  standalone: false,
  templateUrl: './gains-tone-tag-cell.component.html',
  styleUrl: './gains-tone-tag-cell.component.scss'
})
export class GainsToneTagCellComponent<TData = unknown> implements ICellRendererAngularComp {
  protected tag?: ToneTag;

  agInit(params: ToneTagCellParams<TData>): void {
    this.show(params);
  }

  refresh(params: ToneTagCellParams<TData>): boolean {
    this.show(params);
    return true;
  }

  private show(params: ToneTagCellParams<TData>): void {
    this.tag = params.data === undefined ? undefined : params.tagFor(params.data);
  }
}
